import growthbook from "~/lib/ab/growthbook";

export const SALESFORCE_FIELD_PREFILL = "salesforce-field-prefill";

export function isSalesforceFieldPrefillFeatureFlagOn(): boolean {
	return growthbook.isOn(SALESFORCE_FIELD_PREFILL);
}
